// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionV2NdcGetByIdIdGetByIdResponse {
    static getAttributeTypeMap() {
        return PrescriptionV2NdcGetByIdIdGetByIdResponse.attributeTypeMap;
    }
}
PrescriptionV2NdcGetByIdIdGetByIdResponse.discriminator = undefined;
PrescriptionV2NdcGetByIdIdGetByIdResponse.additionalProperties = false;
PrescriptionV2NdcGetByIdIdGetByIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PrescriptionNdcModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=prescriptionV2NdcGetByIdIdGetByIdResponse.js.map